import { render, staticRenderFns } from "./RoleAdd.vue?vue&type=template&id=654fb497&scoped=true"
import script from "./RoleAdd.vue?vue&type=script&lang=js"
export * from "./RoleAdd.vue?vue&type=script&lang=js"
import style0 from "./RoleAdd.vue?vue&type=style&index=0&id=654fb497&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654fb497",
  null
  
)

export default component.exports